export default "__VITE_ASSET__Bj4EzqoG__"